/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest interface.
 */
export function instanceOfFxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest(value) {
    if (!('InviteToken' in value) || value['InviteToken'] === undefined)
        return false;
    return true;
}
export function FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestFromJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestFromJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'InviteToken': json['InviteToken'],
    };
}
export function FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestToJSON(json) {
    return FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestToJSONTyped(json, false);
}
export function FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'InviteToken': value['InviteToken'],
    };
}
//# sourceMappingURL=FxIdWebFeaturesAuthAuthenticateFromEmailInviteRequest.js.map